__webpack_require__.p = "/kasa/";